module.exports = "<body>\n  <div class=\"preloader\" id=\"preloader\"\n    [style.display]=\"screenService && screenService.isShowLoader ? 'block' : 'none'\">\n    <div class=\"preloader-in\">\n      <span></span>\n      <span></span>\n      <span></span>\n      <span></span>\n    </div>\n  </div>\n  <app-header></app-header>\n  <router-outlet></router-outlet>\n  <update-password-modal></update-password-modal>\n  <agreements-modal></agreements-modal>\n</body>\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/app.component.html
// module id = ./src/app/app.component.html
// module chunks = main